/**
 * Lightweight logger that silences debug noise in production but keeps
 * `error` calls (essential for support tickets / Sentry-like setups).
 *
 * Usage:
 *   import logger from '@/lib/logger';
 *   logger.error('failed to load X', err);
 *   logger.warn('something looks off', data);
 *   logger.info('user clicked');     // dev only
 *   logger.debug('payload', payload); // dev only
 *
 * Behaviour:
 *   - In dev (NODE_ENV !== 'production') everything goes to the browser console.
 *   - In production only `error` is emitted; the rest is no-op.
 */
const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

const logger = {
  debug: isProd ? noop : (...args) => console.debug(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  log: isProd ? noop : (...args) => console.log(...args),
  warn: isProd ? noop : (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
